import { PublicInterest } from "@entity/domain/models/public-interest/public-interest.model";

export class CreatePublicInterest {
    constructor(
        public organizationType: PublicInterest["organizationType"],
        public entity: PublicInterest["entity"],
        public date: PublicInterest["date"],
    ) {}
}
